export const USER_ROLES = {
  OWNER: "OWNER",
  MEMBER: "MEMBER",
};
export const USER_ROLE_OPTIONS = [
  { id: USER_ROLES.OWNER, label: "Owner" },
  { id: USER_ROLES.MEMBER, label: "Member" },
];
